module.exports = __webpack_public_path__ + "img/INSIGHTS (6).0ea9f21a.png";